import { DefaultValue } from 'recoil';
import { unStringfy } from '../utils/functions';

export const localPersistEffect = ({ onSet, setSelf, node }: any) => {
  // Attempt to load persisted data from localStorage
  try {
    const storedItems = localStorage.getItem(node.key);
    if (storedItems != null) {
      setSelf(unStringfy(storedItems));
    }
  } catch (error) {
    console.error(`Error reading localStorage for key ${node.key}:`, error);
  }

  // When the atom state changes, try to persist it to localStorage
  onSet((newItems: any) => {
    try {
      if (newItems instanceof DefaultValue) {
        localStorage.removeItem(node.key);
      } else {
        const serialized = JSON.stringify(newItems);
        localStorage.setItem(node.key, serialized);
      }
    } catch (error) {
      // Catch quota errors (or any other errors) to prevent app crashes
      if ((error as Error).name === 'QuotaExceededError') {
        console.error(`QuotaExceededError for key ${node.key}:`, error);
        // Optionally add fallback logic here (e.g., clear storage or notify the user)
      } else {
        console.error(
          `Error saving to localStorage for key ${node.key}:`,
          error,
        );
      }
    }
  });
};
